var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 10 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.6,
  d: "M10 9.594.39-.002 0 .402l9.611 9.596z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.6,
  d: "M0 9.594 9.61-.002l.39.404L.389 9.998z"
})));
export default SvgClose;